import { boolean, object, string } from 'yup';

import { TelegramAuthBotFormValues } from 'v2/types/TelegramAuthBotModel';

export const initialValues: TelegramAuthBotFormValues = {
  token: '',
  name: '',
  isActive: true,
};

export const validationSchema = object().shape({
  token: string()
    .required('Token is required')
    .matches(/^\d+:.+$/, 'Invalid token format. Expected: 123456:ABCdef...'),
  name: string(),
  isActive: boolean(),
});
